import axios from '../../../axios';
import ICandidateSubmissionSettingsSearch from '../types/ICandidateSubmissionSettingsSearch';
import ISubmissionSettingsTemplate from '../types/ISubmissionSettingsTemplate';
import ISubmissionStageStatusSetting from '../types/ISubmissionStageStatusSetting';

const url = '/candidatesearch/api/';

export const getCandidateSubmissionSettingsTemplatesList = (
  payload: ICandidateSubmissionSettingsSearch
) => axios.post(`${url}candidate-fields-submission-settings/search`, payload);

export const deleteCandidateSubmissionSettings = (templateName: string, workspaceId: string) =>
  axios.delete(`${url}delete`, {
    params: {
      templateName,
      workspaceId,
    },
  });

export const saveSubmissionTemplate = (payload: ISubmissionSettingsTemplate) =>
  axios.post(`${url}candidate-fields-submission-settings`, payload);

export const suggestTemplateNames = (searchTerm: string) =>
  axios.get(`${url}suggest/${searchTerm}`);

export const getTemplatesByWorkspaceId = (workspaceId: string) =>
  axios.get(`${url}candidate-fields-submission-settings/by-workspaceId/${workspaceId}`);

export const getCandidateSubmissionSettingsTemplate = (templateName: string, workspaceId: string) =>
  axios.get(`${url}candidate-fields-submission-settings`, {
    params: {
      templateName,
      workspaceId,
    },
  });

export const getSubmissionStageStatus = () => axios.get(`${url}submission-stage-status-settings`);

export const saveSubmissionStageStatusSetting = (payload: ISubmissionStageStatusSetting[]) =>
  axios.post(`${url}submission-stage-status-settings/save`, payload);
